import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'

import { modifyGroupedIdsSort, sortArrayBy } from '@domain-group/javascript-utils'

import useDispatch from '@hooks/useDispatch'

import * as providerPriceListItemOptionValueActions from '@redux/modules/providerPriceListItemOptionValue'
import { AppDispatch } from '@redux/store'

import type {
  ProviderPriceListItemOptionValueModel, ProviderPriceListItemOptionValueRequestOptions,
} from '@models/types'

type DefaultState = {
  sortedIds: (number)[],
}

type SetState = (state: Partial<DefaultState>) => void

type ModifyProviderPriceListItemOptionValueSortParams = {
  dispatch: AppDispatch,
  fromIndex: number,
  payload: any,
  requestOptions: ProviderPriceListItemOptionValueRequestOptions,
  setState: SetState,
  sortedIds: (number)[],
  toIndex: number,
}

const modifyProviderPriceListItemOptionValueSort = (params: ModifyProviderPriceListItemOptionValueSortParams) => {
  const {
    dispatch, fromIndex, payload, requestOptions, setState, sortedIds, toIndex,
  } = params

  const groupedIds = modifyGroupedIdsSort(fromIndex, toIndex, payload, { sortedIds })

  setState({ sortedIds: groupedIds.sortedIds })

  const { updateSortOrder: updateFn } = providerPriceListItemOptionValueActions

  return dispatch(updateFn({ sortOrder: groupedIds.sortedIds }, requestOptions))
}

type UseEditProviderPriceListItemOptionValueSortOptions = {
  filteredProviderPriceListItemOptionValues: ProviderPriceListItemOptionValueModel[],
}

const defaultState: DefaultState = {
  sortedIds: [],
}

function useEditProviderPriceListItemOptionValueSort(options: UseEditProviderPriceListItemOptionValueSortOptions) {
  const { filteredProviderPriceListItemOptionValues = [] } = options || {}

  const [state, setState] = useSetState(defaultState)
  const { sortedIds } = state

  const sortedSections = sortArrayBy(filteredProviderPriceListItemOptionValues, 'asc', 'sort')

  // Set current sort into state
  useEffect(() => {
    const sortedSectionIds = sortedSections.map(item => item?.id)
    setState({ sortedIds: sortedSectionIds })
  }, [filteredProviderPriceListItemOptionValues.length])

  const dispatch = useDispatch()

  return {
    callbacks: {
      modifyProviderPriceListItemOptionValueSort: (
        fromIndex: number,
        payload: { [key: string]: any },
        toIndex: number,
        entityOptions?: ProviderPriceListItemOptionValueRequestOptions,
      ) => modifyProviderPriceListItemOptionValueSort({
        dispatch,
        fromIndex,
        payload,
        // @ts-expect-error TS2322
        requestOptions: entityOptions,
        setState,
        sortedIds,
        toIndex,
      }),
    },
    sortedIds,
  }
}

export default useEditProviderPriceListItemOptionValueSort
